import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { CarouselCard } from '../../components/Carousel';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';
import { ONLINE_LOCATION_SLUG } from '../../constants';
import { useEnvContext, useLocationContext } from '../../context';

import { CATEGORY_CONTENT_MAP } from './index';
import { categorySort } from './utils';
import styles from './WaysToTour.module.scss';

export type Category = {
    display_name: string;
    url: string;
    tag: string;
    id: string;
};

export interface WaysToTourProps {
    categories?: Category[];
}

const getCategoryBrowseUrl = (
    categorySlug: string,
    locationSlug: string,
    uses_language_subdirectory: boolean | undefined,
    locale: string | undefined,
) => {
    if (uses_language_subdirectory) {
        return `/${locale}/b/${locationSlug}/${categorySlug}/`;
    }
    return `/b/${locationSlug}/${categorySlug}/`;
};

export const WaysToTour: React.FunctionComponent<WaysToTourProps> = (props) => {
    const { env } = useEnvContext();
    const { shortPlaceName, location_slug } = useLocationContext();

    let title = gettext('Ways to Tour %(geo)s', {
        geo: shortPlaceName,
    });
    let subTitle = gettext(
        'Explore the best of %(geo)s through these popular event categories',
        { geo: shortPlaceName },
    );

    if (location_slug == ONLINE_LOCATION_SLUG) {
        title = gettext('Ways to explore Online');
        subTitle = gettext(
            'Explore the best Online activities through these popular event categories',
        );
    }

    categorySort(props?.categories);

    const waysToTourSlides = props?.categories?.map((category) => {
        return (
            <a
                className={styles.categoryBrowseLink}
                data-testid="category-browse-link"
                key={category?.id}
                href={getCategoryBrowseUrl(
                    CATEGORY_CONTENT_MAP[category?.tag || ''].slug,
                    location_slug || '',
                    env?.localeInfo.uses_language_subdirectory,
                    env?.localeInfo.locale,
                )}
            >
                <CarouselCard
                    title={CATEGORY_CONTENT_MAP[category?.tag || ''].title}
                    imageUrl={
                        CATEGORY_CONTENT_MAP[category?.tag || ''].imageUrl
                    }
                    imageLoading={'lazy'}
                    extraStyles={styles.waysToTourCard}
                />
            </a>
        );
    });

    return (
        <>
            {props.categories?.length ? (
                <ThingsToDoSection wrappingClasses={styles.waysToTourSection}>
                    <SimpleCarousel
                        headerTitle={title}
                        subtitle={subTitle}
                        slidesVisible={{ desktop: 7, tablet: 6 }}
                    >
                        {waysToTourSlides}
                    </SimpleCarousel>
                </ThingsToDoSection>
            ) : (
                <></>
            )}
        </>
    );
};
